export function calculateUnfulfilledQuantity({
  wanted = 1,
  purchased = 0,
  quantityInBasket = 0,
}: {
  wanted?: number;
  purchased?: number;
  quantityInBasket?: number;
} = {}): number {
  const computed = wanted - (quantityInBasket + purchased);
  return computed > 1 ? computed : 1;
}
